module.exports = __webpack_public_path__ + "static/media/search-white.48dc8225.svg";